export enum Countries {
  Canada = 'Canada',
  China = 'China',
  UnitedStatesOfAmerica = 'United States Of America',
  USA = 'USA'
}
